import * as angular from "angular";
import {IController} from "angular";
import * as moment from "moment";
import {Observable, forkJoin} from "rxjs";
import {map} from "rxjs/operators";
import {VisitPlanModel} from "../../models/visit-plan.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {VisitPlanScheduleFacadeService} from "../../angular/services/visit-plan-schedule-facade.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import * as _ from "lodash";
import {VisitScheduleDayModel} from "../../models/visit-schedule-day.model";
import {isVisitScheduleDayDispatchedById} from "../../models/visit-schedule-day.functions";
import {VisitScheduleResourceModel} from "../../models/visit-schedule-resource.model";
import {VisitPlanHttpService} from "../../angular/services/visit-plan-http.service";
import {SchedulingProjectDialogService} from "../../services/scheduling-project-dialog.service";
import {SchedulingProjectAlertsService} from "../../services/scheduling-project-alerts.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {CommonsFacadeService} from "../../../commons/angular/state/commons/commons-facade.service";
import {VisitScheduleModel} from "../../models/visit-schedule.model";
import {VisitScheduleStatusEnum} from "../../enums/visit-schedule-status.enum";
import {VisitScheduleAnalysisModel} from "../../models/visit-schedule-analysis.model";

export class VisitPlanDispatchViewComponent implements IController {

  visitPlan: VisitPlanModel;
  // from: number;
  // to: number;
  visitSchedule: VisitScheduleModel;
  analysis?: VisitScheduleAnalysisModel;
  dispatchVisitScheduleDays: VisitScheduleDayModel[];
  projectVisitScheduleDays: VisitScheduleDayModel[];
  branchIds: string[];
  programTypeAliasMap: { [key: string]: string };
  jobs: any[];
  resources: any[];
  onReoptimizeRoutes: Function;
  onCloseView: Function;


  public page: number = 0;
  public size: number = 20;
  public routes: any[] = [];
  public agentColorMap: any;
  public colorPallet: any;
  public isLoading: boolean = false;
  public serviceAreas: any[] = [];
  private serviceAreasRef: any;
  public paginationData: any;
  public selectedAgentIds: string[] = [];
  public selectedBranchIds: string[] = [];
  public selectedActivityBranchIds: string[] = [];
  public hiddenRouteIds: string[] = [];
  public visitScheduleStatuses: typeof VisitScheduleStatusEnum = VisitScheduleStatusEnum;
  public hasCompletedVisitScheduleDays: boolean;
  public selectedJobIds: string[] = [];
  public selectedJobs: any[] = [];

  public isPublishing: boolean = false;

  constructor(private $timeout, private splitService: SplitService, private visitPlanScheduleFacadeService: VisitPlanScheduleFacadeService,
              private commonsService: CommonsService, private commonsConstants, private $serviceArea,
              private visitPlanHttpService: VisitPlanHttpService, private schedulingProjectDialogService: SchedulingProjectDialogService,
              private schedulingProjectAlertsService: SchedulingProjectAlertsService, private confirmDialogService: ConfirmDialogService,
              private commonsFacadeService: CommonsFacadeService, private TimelineService) {
  }

  $onInit() {

    this.colorPallet = this.commonsConstants.colorPalletTwo;
    this.serviceAreasRef = this.$serviceArea();


    if (this.jobs?.length) {
      this.setServiceAreasByJobs(this.jobs);
    }

    // if (!this.from) {
    //   this.from = this.visitPlan.from;
    // }
    //
    // if (!this.to) {
    //   this.to = this.visitPlan.to;
    // }

    this._getRoutes();

    // this.jobsSubscription = this.visitPlanScheduleFacadeService.selectAllJobs().subscribe(jobs => {
    //   this.jobs = jobs;
    //   this.$timeout(() => {
    //   }, 0);
    // })

    this.hasCompletedVisitScheduleDays = this.dispatchVisitScheduleDays.some((vsd) => vsd.status === 'Completed');
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.jobs && !changes.jobs.isFirstChange()) {
      if (this.jobs?.length) {
        this.setServiceAreasByJobs(this.jobs);
      }
    }

    // if (changes.visitScheduleDays && !changes.visitScheduleDays.isFirstChange()) {
    //   this.isDisableDispatch = !this.dispatchVisitScheduleDays.every((vsd) => vsd.totals.published)
    //     || this.dispatchVisitScheduleDays.every((vsd) => vsd.totals.dispatched)
    //     || this.visitPlan.hasNotSyncedChanges;
    // }

    if (changes.visitSchedule && !changes.visitSchedule.isFirstChange()) {
      const currentVisitSchedule = changes.visitSchedule.currentValue;
      const previousVisitSchedule = changes.visitSchedule.previousValue;

      if (previousVisitSchedule?.status === this.visitScheduleStatuses.Processing && currentVisitSchedule.status === this.visitScheduleStatuses.Ongoing) {
        this._getRoutes();
      }

      if (previousVisitSchedule && previousVisitSchedule.totalsUpdatedAt < currentVisitSchedule.totalsUpdatedAt) {
        this._refreshDispatchVisitScheduleDays();
      }
    }
  }

  $onDestroy() {
    // this.jobsSubscription.unsubscribe();
  }

  onPaginationChange(page) {
    this.page = page - 1;

    // this._setStateParams();
    this._getRoutes();
  }

  onBranchSelect(ids) {
    this.selectedBranchIds = ids;
    this._getRoutes();
  }

  onActivityBranchSelect(ids) {
    this.selectedActivityBranchIds = ids;
    this._getRoutes();
  }

  onAgentSelect(ids) {
    this.selectedAgentIds = ids;
    this._getRoutes();
  }

  onHiddenRouteIdsChange(ids) {
    this.hiddenRouteIds = ids;
  }

  onToggleRouteDisplay(id, isEnabled) {
    if (isEnabled) {
      this.hiddenRouteIds = _.filter(this.hiddenRouteIds, function (rid) {
        return rid !== id;
      })
    } else {
      this.hiddenRouteIds = this.hiddenRouteIds.concat([id]);
    }
  }

  reoptimizeRoutes() {
    const routeIds = _.map(this.routes, 'id');
    this.onReoptimizeRoutes({routeIds: routeIds});
  }

  onMoveActivity(jobIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds) {
    const requestPayload = this.TimelineService.getMovedTaskPayload(jobIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds);

    this.visitPlanHttpService.editRoute(this.visitPlan.id, this.visitPlan.scheduleId, requestPayload, {group: false}).subscribe((updatedRoutes) => {
      const routesCopy = angular.copy(this.routes);
      updatedRoutes.forEach(r => {
        const routeIndex = this.routes.findIndex(route => route.id === r.id);
        if (routeIndex !== -1) {
          routesCopy[routeIndex] = r;
        }
      })
      this.routes = routesCopy;
      this.$timeout(() => {
      }, 0);
    })
  }


  onMoveJobs(payload) {
    const requestPayload = this.TimelineService.getMovedTaskPayload(payload.jobIds, payload.fromRouteId, payload.toRouteId, payload.fromOrderedIds, payload.toOrderedIds);

    this.visitPlanHttpService.editRoute(this.visitPlan.id, this.visitPlan.scheduleId, requestPayload, {group: false}).subscribe((updatedRoutes) => {
      // this.visitPlanRoutes = _.unionBy(updatedRoutes, this.visitPlanRoutes, 'id');
      this.$timeout(() => {
      }, 0);
    })
  }

  onDatesBrowse(isNext) {
    const dispatchVsdIndex = this.projectVisitScheduleDays.findIndex(vsd => vsd.id === this.dispatchVisitScheduleDays[0].id);

    if (isNext && !!this.projectVisitScheduleDays[dispatchVsdIndex + 1]) {
      this.dispatchVisitScheduleDays = [this.projectVisitScheduleDays[dispatchVsdIndex + 1]];
      this._getRoutes();
    } else if (!isNext && !!this.projectVisitScheduleDays[dispatchVsdIndex - 1]) {
      this.dispatchVisitScheduleDays = [this.projectVisitScheduleDays[dispatchVsdIndex - 1]];
      this._getRoutes();
    }
  }

  onLeftOverMultipleJobSelect(jobIds) {
    //If some are not selected yet select all of them else remove all of them.
    // if (!!_.difference(jobIds, this.selectedJobIds).length) {
    //   this.selectedJobIds = _.uniq(_.concat(this.selectedJobIds, jobIds));
    // } else {
    //   this.selectedJobIds = _.difference(this.selectedJobIds, jobIds);
    // }

    this.selectedJobIds = jobIds;
    // this._setSelectedLeftoverIds(this.selectedJobIds);
    // this.jobs = this._getSortedJobs(this.jobs);
    this.setSelectedJobs();
  }

  isDispatchDisabled() {
    return !!(!this.dispatchVisitScheduleDays.every((vsd) => vsd.totals.published) ||
      this.dispatchVisitScheduleDays.every((vsd) => vsd.totals.dispatched) ||
      this.visitPlan.hasNotSyncedChanges ||
      this.visitSchedule?.editedAfterPublish);
  }

  isPublishVisible() {
    return this.dispatchVisitScheduleDays.some((vsd) => vsd.totals.totalRoutes > 0);
  }

  isActionBlocked(): boolean {
    if (!this.visitPlan?.isArchive) return false;
    this.schedulingProjectAlertsService.deletedProjectActionBlocked();
    return true;
  }

  onPublishVisitScheduleDays($event?) {
    if (this.isActionBlocked()) return;

    this._getBlockingConflictResourceHolderIds().subscribe((resourceHolderIds) => {
      if (resourceHolderIds.length) {
        this.schedulingProjectDialogService.showPublishConflictsDialog($event).then((goToAvailability) => {
          if (goToAvailability) {
            this._openConflictAvailability($event, resourceHolderIds);
          }
        });
        return;
      }

      const text = 'Please note you are about to publish the planned schedules and notify all relevant employees. Would you like to proceed?';
      this.confirmDialogService.confirm('Publish', text, $event)
        .then(() => {
          this._publishVisitScheduleDays();
        })
        .catch(() => {
        });
    });
  }

  // **************************
  //      Private methods
  // **************************

  private _publishVisitScheduleDays() {
    this.isPublishing = true;
    this.commonsFacadeService.setLoaderOn();

    const params = {visitScheduleDayIds: this.dispatchVisitScheduleDays.map(d => d.id)};

    this.visitPlanScheduleFacadeService.publishVisitSchedule(this.visitPlan.id, this.visitPlan.scheduleId, params).subscribe({
      next: () => {
        this.dispatchVisitScheduleDays.forEach((vsd) => {
          vsd.totals.published = true;
          vsd.totals.partialPublished = false;
        });
        this.schedulingProjectAlertsService.publishVisitScheduleSuccess();
      },
      error: () => {
        this.schedulingProjectAlertsService.publishVisitScheduleError();
        this.isPublishing = false;
        this.commonsFacadeService.setLoaderOff();
      },
      complete: () => {
        this.isPublishing = false;
        this.commonsFacadeService.setLoaderOff();
        this.$timeout(() => {
        }, 0);
      }
    });
  }

  private _openConflictAvailability(event, resourceHolderIds: string[]) {
    const dates = this.dispatchVisitScheduleDays.map((vsd) => vsd.date);

    this.schedulingProjectDialogService.showAvailabilityDialog(
      this.visitPlan,
      this.visitPlan.scheduleId,
      this.branchIds,
      moment(Math.min(...dates)).startOf('day').valueOf(),
      moment(Math.max(...dates)).endOf('day').valueOf(),
      this.visitPlan.zoneId,
      event,
      resourceHolderIds
    ).then((data) => {
      if (data?.success || data?.refreshSchedule) {
        this._getRoutes();
      }
    });
  }

  // Agents whose conflict is NOT yet solved (no valid replacement availability alongside it for
  // that same day) for the day(s) currently being viewed/dispatched — used to decide whether
  // publish should be blocked at all. A conflict only counts here if the conflicting availability
  // actually has a route on it; a conflict on a routeless availability has nothing to clash with,
  // so it shouldn't block publish. Mirrors visit-plan-view's project-wide version, scoped to
  // dispatchVisitScheduleDays only.
  private _getBlockingConflictResourceHolderIds(): Observable<string[]> {
    const dayRoutesQuery = {
      visitScheduleDayIds: this.dispatchVisitScheduleDays.map((vsd) => vsd.id),
      size: 1000,
      page: 0
    };

    return forkJoin([
      this._getResourceConflictData(),
      this.visitPlanScheduleFacadeService.getVisitScheduleRoutesPagination(this.visitPlan.id, this.visitPlan.scheduleId, dayRoutesQuery)
    ]).pipe(
      map(([{resources, conflictSet}, routesPage]) => {
        const resourceIdsWithRoutes = new Set<string>();
        (routesPage?.content || []).forEach((route) => {
          if (route.resource?.id) {
            resourceIdsWithRoutes.add(route.resource.id);
          }
        });

        const groups = new Map<string, VisitScheduleResourceModel[]>();
        resources.forEach((r) => {
          const key = `${r.resourceHolderId}_${r.visitScheduleDayId}`;
          if (!groups.has(key)) {
            groups.set(key, []);
          }
          groups.get(key).push(r);
        });

        const blockingAgentIds: string[] = [];
        groups.forEach((groupResources) => {
          if (isVisitScheduleDayDispatchedById(this.dispatchVisitScheduleDays, groupResources[0].visitScheduleDayId)) {
            return;
          }
          const hasConflict = groupResources.some((r) => conflictSet.has(r.id) && resourceIdsWithRoutes.has(r.id));
          const hasValidAvailability = groupResources.some((r) => !conflictSet.has(r.id));
          if (hasConflict && !hasValidAvailability) {
            blockingAgentIds.push(groupResources[0].agentId);
          }
        });

        return _.uniq(blockingAgentIds);
      })
    );
  }

  private _getResourceConflictData(): Observable<{ resources: VisitScheduleResourceModel[], conflictSet: Set<string> }> {
    const dates = this.dispatchVisitScheduleDays.map((vsd) => vsd.date);
    const query = {
      from: moment(Math.min(...dates)).startOf('day').valueOf(),
      to: moment(Math.max(...dates)).endOf('day').valueOf()
    };

    return forkJoin([
      this.visitPlanHttpService.getResourcesList(this.visitPlan.id, this.visitPlan.scheduleId, query),
      this.visitPlanHttpService.getResourceConflicts(this.visitPlan.id, this.visitPlan.scheduleId, query)
    ]).pipe(
      map(([resources, conflictIds]) => ({resources, conflictSet: new Set(conflictIds)}))
    );
  }

  onApproveAndDispatch() {
    this.schedulingProjectDialogService.dispatchRoutesConfirmDialog(this.visitPlan, this.dispatchVisitScheduleDays)
      .then((payload) => {
        const dispatchPayload = {
          visitScheduleDayIds: this.dispatchVisitScheduleDays.map(d => d.id),
          dispatchLeftovers: payload.isDispatchLeftovers,
          autoAssignRoutes: payload.autoAssignRoutes
        }

        this._onDispatchRoutes(dispatchPayload)
      })
  }

  private _onDispatchRoutes(payload) {
    this.commonsFacadeService.setLoaderOn();

    this.visitPlanHttpService.dispatchVisitSchedule(this.visitPlan.id, this.visitPlan.scheduleId, payload).subscribe(
      {
        next: () => {
          // this.onCloseView();
        },
        error: () => {
          this.commonsFacadeService.setLoaderOff();
        },
        complete: () => {
          this.commonsFacadeService.setLoaderOff();
        }
      }
    )
  }

  // dispatchVisitScheduleDays is a local copy (next/prev navigation reassigns it), so the parent's
  // days refresh doesn't reach it — re-fetch its totals so dispatch state (e.g. after Approve & Dispatch) stays current.
  private _refreshDispatchVisitScheduleDays() {
    const dates = this.dispatchVisitScheduleDays.map((vsd) => vsd.date);
    const params = {
      from: moment(Math.min(...dates)).startOf('day').valueOf(),
      to: moment(Math.max(...dates)).endOf('day').valueOf()
    };

    this.visitPlanHttpService.getVisitScheduleDaysData(this.visitPlan.id, this.visitPlan.scheduleId, params)
      .subscribe((res: { list: VisitScheduleDayModel[], cursor: string }) => {
        this.dispatchVisitScheduleDays = this.dispatchVisitScheduleDays.map((vsd) => _.find(res.list, {id: vsd.id}) || vsd);
        this.$timeout(() => {
        }, 0);
      });
  }

  private initAgentColorMap() {
    this.agentColorMap = {}

    this.routes.forEach(r => {
      this.agentColorMap[r.resource.agentId] = this.commonsService.getColorById(r.resource.agentId, this.colorPallet)
    })
  }

  private _getRoutes() {

    this.isLoading = true;
    this.routes = [];

    const routesQuery = {
      // from: this.from,
      // to: this.to,
      visitScheduleDayIds: this.dispatchVisitScheduleDays.map(d => d.id),
      projectBranchIds: this.selectedBranchIds,
      activityBranchIds: this.selectedActivityBranchIds,
      agentIds: this.selectedAgentIds,
      size: this.size,
      page: this.page
    }

    this.visitPlanScheduleFacadeService.getVisitScheduleRoutesPagination(this.visitPlan.id, this.visitPlan.scheduleId, routesQuery)
      .subscribe(
        {
          next: (paginationData) => {
            this.paginationData = paginationData;
            this.routes = paginationData.content;
            // this._getRouteJobs();
            this.initAgentColorMap();
            this.$timeout(() => {
            }, 0);
          },
          error: () => {
            this.isLoading = false;
          },
          complete: () => {
            this.isLoading = false;
          }
        }
      )
  }

  // private _getRouteJobs() {
  //   const jobsQuery = {
  //     routeIds: this.routes.map(r => r.id),
  //     limit: 1000
  //   }
  //
  //   this.visitPlanScheduleFacadeService.getManyJobs(this.visitPlan.id, this.visitPlan.scheduleId, jobsQuery)
  // }

  private setServiceAreasByJobs(jobs) {
    const areaIds = _.chain(jobs)
      .map('areaIds')
      .flatten()
      .uniq()
      .value();

    this.serviceAreasRef.$asyncValues(areaIds)
      .then((serviceAreas) => {
        this.serviceAreas = _.uniqBy(this.serviceAreas.concat(serviceAreas), 'areaId');
      })
  }

  private setSelectedJobs() {
    this.selectedJobs = _.chain(this.selectedJobIds)
      .map((id) => {
        return _.find(this.jobs, (j) => {
          return j.id === id;
        })
      })
      .compact()
      .value();
  }

}

angular
  .module('bringoz.admin.scheduling-project')
  .component('visitPlanDispatchView', {
    bindings: {
      visitPlan: '<',
      // from: '<?',
      // to: '<?',
      visitSchedule: '<',
      analysis: '<',
      dispatchVisitScheduleDays: '<?',
      projectVisitScheduleDays: '<?',
      programTypeAliasMap: '<?',
      resources: '<?',
      jobs: '<?',
      branchIds: '<?',
      onReoptimizeRoutes: '&',
      onCloseView: '&'
    },
    template: require('./visit-plan-dispatch-view.html').default,
    controller: VisitPlanDispatchViewComponent
  });
